import { Link } from "react-router";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
    CalendarIcon,
    DocumentTextIcon,
    ClockIcon,
    PhoneIcon,
    EnvelopeIcon,
} from "@heroicons/react/24/outline";
import { EyeIcon } from "@heroicons/react/16/solid";
import { formatTime, formatDateTimeString } from "@/utils/format/date-time";

export const AppointmentCard = ({ appointment }) => {
    const redirectLink =
        appointment.statusID == 2
            ? `/clinician/appointments?tab=upcoming&id=${appointment.appointmentGuid}`
            : `/clinician/appointments?tab=waiting-your-approval&id=${appointment.appointmentGuid}`;

    return (
        <Card className="grid-cols-12">
            <div className="relative col-span-full flex flex-col gap-2 text-base/5 text-sm text-neutral-500">
                <div className="flex flex-wrap content-start items-end gap-2">
                    <p className="text-base font-semibold text-darkgreen-500">
                        {appointment.serviceTitle}
                    </p>
                    <Badge
                        variant={
                            appointment.statusID === 0 ||
                            appointment.statusID === 1
                                ? "warning"
                                : appointment.statusID === 2
                                  ? "success"
                                  : "danger"
                        }
                    >
                        {appointment.statusID === 0 ||
                        appointment.statusID === 1
                            ? "Waiting Approval"
                            : appointment.statusID === 2
                              ? "Confirmed"
                              : "Declined"}
                    </Badge>
                </div>
                <div className="flex items-center gap-1">
                    <CalendarIcon className="size-5" />
                    <p>{formatDateTimeString(appointment.startDate)}</p>
                </div>
                <div className="flex items-center gap-1">
                    <ClockIcon className="size-5" />
                    <p>{formatTime(appointment.startDate)}</p>
                </div>
                {appointment.statusID == 0 && appointment.notes && (
                    <div className="flex items-center gap-1">
                        <DocumentTextIcon className="size-5" title="Notes" />
                        <p>{appointment.notes}</p>
                    </div>
                )}
                <div className="flex flex-col items-start gap-3 md:flex-row">
                    <div className="flex items-center gap-1">
                        <PhoneIcon className="size-5" />
                        <p>
                            <a
                                href={`tel:${appointment.phoneNumber}`}
                                className="hover:underline"
                            >
                                {appointment.phoneNumber}
                            </a>
                        </p>
                    </div>
                    <div className="flex items-center gap-1">
                        <EnvelopeIcon className="size-5" />
                        <p>
                            <a
                                href={`mailto:${appointment.email}`}
                                className="hover:underline"
                            >
                                {appointment.email}
                            </a>
                        </p>
                    </div>
                </div>
                <div className="ms-auto mt-auto md:absolute md:right-0 md:bottom-0">
                    <Button type="button" variant="primary" size="sm" asChild>
                        <Link to={redirectLink}>
                            <EyeIcon />
                            View
                        </Link>
                    </Button>
                </div>
            </div>
        </Card>
    );
};
